import fp from 'lodash/fp'
import axios from 'axios'
import { combine, withEffect } from 'react-hooks-combine'
import { toaster } from 'utils/toast-wrapper'

export const XHRErrorCatcher = combine(
  withEffect(() => {
    const interceptor = axios.interceptors.response.use(
      fp.identity,
      (error) => {
        // Skip showing toaster if request has skipErrorToaster flag
        if (!error.config?.skipErrorToaster) {
          toaster.error(error.message)
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axios.interceptors.response.eject(interceptor)
    }
  }, [])
)(({ children }) => children)
